<template>
<!-- eslint-disable -->
<svg xmlns="http://www.w3.org/2000/svg" viewBox="-50 -50 600 600">
  <path d="M484.108,122.227h0a29.341,29.341,0,0,0-41.495,0L249.952,314.887,57.209,122.144a29.428,29.428,0,0,0-41.495,0h0a29.428,29.428,0,0,0,0,41.5L208.457,356.382h0l41.5,41.5L484.108,163.722A29.341,29.341,0,0,0,484.108,122.227Z"/>
</svg>
</template>
<script>
export default {
  name: 'ArrowDownIcon'
};
</script>
